var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('YourBadgesTab',{attrs:{"text":_vm.badgesGuideData?.content?.text,"subText":_vm.badgesGuideData?.content?.subText,"videoUrl":_vm.badgesGuideData?.content?.videoUrl,"videoThumbnail":_vm.badgesGuideData?.content?.videoThumbnail,"showGuideCard":_vm.showBadgesGuideCard},on:{"guide-close":_vm.handleBadgesGuideClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }